import { ReportBI } from '../services';
import { withoutDefaults } from '../util';
import {
  cairoDataExtensionUnsuccessfulUpdateInServer,
  cairoModalCtaClicked,
  cairoTryAgainClicked,
} from '@wix/bex-utils/@wix/bi-logger-os-data/v2';
import { CustomFieldForm } from './CustomFieldModalState';

export interface DataExtensionStateBIReporterParams {
  reportBi: ReportBI;
}

export class DataExtensionStateBIReporter {
  readonly reportBi: ReportBI;

  constructor(params: Readonly<DataExtensionStateBIReporterParams>) {
    const { reportBi } = params;

    this.reportBi = reportBi;
  }

  reportArchiveFieldModalCtaClicked = (ctaName: string) => {
    this.reportBi(
      withoutDefaults(cairoModalCtaClicked)({
        ctaName,
        modalName: 'Archive custom field',
      }),
    );
  };

  reportDeleteFieldModalCtaClicked = (ctaName: string) => {
    this.reportBi(
      withoutDefaults(cairoModalCtaClicked)({
        ctaName,
        modalName: 'Delete custom field',
      }),
    );
  };

  getBiPermissions(formValues: CustomFieldForm) {
    const { readApps, readUsers, writeApps, writeUsers } = formValues;
    const apps = [];
    const users = [];

    if (readApps) {
      apps.push('Read');
    }

    if (writeApps) {
      apps.push('Write');
    }

    if (readUsers) {
      users.push('Read');
    }

    if (writeUsers) {
      users.push('Write');
    }

    return JSON.stringify({
      'Installed apps': apps.length !== 0 ? apps.join(' and ') : null,
      'Site visitors': users.length !== 0 ? users.join(' and ') : null,
    });
  }

  reportArchiveFieldFailed = ({
    origin,
    formValues,
  }: {
    origin: string;
    formValues?: CustomFieldForm;
  }) => {
    if (!formValues) {
      return;
    }

    this.reportBi(
      withoutDefaults(cairoDataExtensionUnsuccessfulUpdateInServer)({
        actionName: 'Archive',
        errorType: 'Technical issue',
        origin,
        permissions: this.getBiPermissions(formValues),
        fieldType: formValues.type,
        fieldName: formValues.name,
        key: formValues.key,
      }),
    );
  };

  reportArchiveTryAgain = () => {
    this.reportBi(
      withoutDefaults(cairoTryAgainClicked)({
        actionName: 'Archive custom field',
        loaction: 'toast',
      }),
    );
  };

  reportRestoreFieldFailed = ({
    origin,
    formValues,
  }: {
    origin: string;
    formValues?: CustomFieldForm;
  }) => {
    if (!formValues) {
      return;
    }

    this.reportBi(
      withoutDefaults(cairoDataExtensionUnsuccessfulUpdateInServer)({
        actionName: 'Restore',
        errorType: 'Technical issue',
        origin,
        permissions: this.getBiPermissions(formValues),
        fieldType: formValues.type,
        fieldName: formValues.name,
        key: formValues.key,
      }),
    );
  };

  reportRestoreTryAgain = () => {
    this.reportBi(
      withoutDefaults(cairoTryAgainClicked)({
        actionName: 'Restore custom field',
        loaction: 'toast',
      }),
    );
  };
}
